import { html } from "../../render";
import { attr, cn, numberToPxValue } from "../../utils";
export const LP_LOADER_VARIANTS = {
    size: {
        sm: 16,
        base: 24,
        lg: 32,
    },
};
export const LP_LOADER_DEFAULT_VARIANTS = {
    size: "base",
};
function getLoaderSizeValue(size) {
    if (typeof size === "number") {
        return size;
    }
    return LP_LOADER_VARIANTS.size[size];
}
export function LpLoader({ size = LP_LOADER_DEFAULT_VARIANTS.size, label = "Loading", className, } = {}) {
    const sizeValue = numberToPxValue(getLoaderSizeValue(size));
    return html `
        <svg
            data-lp-component="Loader"
            class="${cn("lp-loader", className)}"
            ${attr("style", sizeValue ? `--lp-loader-size: ${sizeValue};` : undefined)}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            stroke="currentColor"
            role="status"
            aria-label="${label}"
        >
            <circle class="lp-loader_track" cx="12" cy="12" r="9.5" fill="none" stroke-width="2" stroke-linecap="round"></circle>
            <circle class="lp-loader_indicator" cx="12" cy="12" r="9.5" fill="none" stroke-width="2" stroke-linecap="round"></circle>
        </svg>
    `;
}
